import { Component, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-contexts-new-context-dashboard',
  templateUrl: './contexts-new-context-dashboard.component.html',
  styleUrls: ['./contexts-new-context-dashboard.component.scss']
})
export class ContextsNewContextDashboardComponent implements OnInit {

  providers;
  types;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-hdd', 'apisecrets-page.new apisecret', '/account/contexts', [new BRoute('account-page.account', '/account'), new BRoute('apisecrets-page.apisecrets', '/account/contexts'), new BRoute('apisecrets-page.new apisecret')]));
  }

}
